var module = angular.module('octopusApp.shared');
var Clipboard = require('Clipboard');

module.directive('copyToClipboard', function() {
    return {
        restrict: 'E',
        transclude: true,
        template: '<span class="copy-to-clipboard clickable" uib-tooltip-html="vm.tooltip" ng-mouseleave="vm.resetCopyToClipboardTooltip()"><ng-transclude></ng-transclude></span>',
        controllerAs: 'vm',
        bindToController: true,
        scope: {
           text: '='
        },
        controller: function($scope, $timeout) {

            var vm = this;

            // Copy-to-clipboard handler
            new Clipboard('.copy-to-clipboard', {
                text: function () {
                    vm.tooltip = "Copied!";
                    $scope.$apply(); // We are outside of angular here
                    if (_.isFunction(vm.text)) {
                        return vm.text();
                    }

                    return vm.text;
                }
            });

            vm.resetCopyToClipboardTooltip = function() {
                // This is delayed so the tooltip text doesn't flicker when moving the mouse away
                $timeout( function() {
                    vm.tooltip = "Copy to clipboard";
                }, 200);
            };

            vm.resetCopyToClipboardTooltip();
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/directives/copy_to_clipboard.js
// module id = 3951711575326649
// module chunks = 1